// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBl4xmGxBHMzYvp-RvvP_zNpA9GW4QDLGs",
  authDomain: "cooc-002.firebaseapp.com",
  projectId: "cooc-002",
  storageBucket: "cooc-002.firebasestorage.app",
  messagingSenderId: "693208794983",
  appId: "1:693208794983:web:5a579644232933404291c2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Use the Australia Southeast region for functions (for Gen 2)
const functions = getFunctions(app, 'australia-southeast1');

export { auth, db, storage, functions };
export default app;